<app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()"
  (toggleMobileNav)="sidenav.toggle()"></app-header>
  <p-toast position="top-right" key="toast" />
<mat-sidenav-container class="mainWrapper blue_theme  light-theme" autosize autoFocus dir="ltr">

  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->

  <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="!isOver" [disableClose]="true"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav"
    [fixedInViewport]="true" fixedBottomGap="0">
    <!-- トグルボタン mat-icon-button mat-mini-fab -->
    <button mat-icon-button color="default" (click)="toggleSidenav()" class="toggle-button"
      aria-label="Toggle navigation" matTooltip="{{ 'ITEM.CLOSE_MENU' | translate }}">
      <mat-icon>menu_open</mat-icon>
    </button>

    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="">
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->

    <main class="">

      <mat-sidenav-container class="mainWrapper blue_theme  light-theme" autosize autoFocus dir="ltr">

        <!-- ============================================================== -->
        <!-- Vertical Sidebar -->
        <!-- ============================================================== -->

        <mat-sidenav #leftMinsidenav [mode]="isMinOver ? 'side' : 'over'" [opened]="!isMinOver"
        [disableClose]="true"
        (openedChange)="onMinSidenavOpenedChange($event)" (closedStart)="onMinSidenavClosedStart()"
          class="sidebarNav onlyIcon"
          [fixedInViewport]="true" fixedBottomGap="0">
          <!-- トグルボタン mat-icon-button mat-mini-fab -->
          <button mat-icon-button color="default" (click)="toggleSidenav()" class="toggle-button"
            aria-label="Toggle navigation" matTooltip="{{ 'ITEM.OPEN_MENU' | translate }}">
            <mat-icon>menu</mat-icon>
          </button>

          <app-sidebar [onlyIcon]="true" ></app-sidebar>
        </mat-sidenav>
        <!-- ============================================================== -->
        <!-- Main Content -->
        <!-- ============================================================== -->
        <mat-sidenav-content class="contentWrapper">
          <!-- ============================================================== -->
          <!-- VerticalHeader -->
          <!-- ============================================================== -->

          <main class="pageWrapper ">
            <!-- ============================================================== -->
            <!-- Outlet -->
            <!-- ============================================================== -->
            <router-outlet></router-outlet>
          </main>
        </mat-sidenav-content>
      </mat-sidenav-container>

    </main>
  </mat-sidenav-content>
</mat-sidenav-container>